// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lUurZ","buttons":"styles_buttons__1kXu6"};